import axios from "axios";
import { cnxAPI, notifica, getUser, show_ldr, responseBuild } from "./utils";
import api from '../service/api'

const service = api;

var a = null,
  b = null;
//Función que trae los combos para los filtros
function getVacantes(_callback) {
  var lbl = document.getElementById("lbl_util"),
    lbf = document.getElementById("lbl_fltrs_orft");
  
  // Construir parámetros para GET
  let params = new URLSearchParams();
  
  // Si hay filtros en lbl_util, parsear y agregar a params
  if (lbl && lbl.innerText !== "") {
    try {
      const utilParams = JSON.parse("{" + lbl.innerText + "}");
      Object.keys(utilParams).forEach(key => {
        params.append(key, utilParams[key]);
      });
    } catch (e) {
      console.warn("Error parsing lbl_util params:", e);
    }
  }
  
  // Si hay filtros en lbl_fltrs_orft, parsear y agregar a params
  if (lbf && lbf.innerText !== "" && (!lbl || lbl.innerText === "")) {
    try {
      const filterParams = JSON.parse(lbf.innerText);
      Object.keys(filterParams).forEach(key => {
        params.append(key, filterParams[key]);
      });
    } catch (e) {
      console.warn("Error parsing lbl_fltrs_orft params:", e);
    }
  }
  
  if (params.toString() === "") {
    params.append("fechas", "0");
  }
  
  show_ldr(true);
  api.get('solicitudes/consulta-solicitudes?' + params.toString(), {})
    .then(function (response) {
      if (response.status !== 200) {
        notifica("warning", response.data.message, "Error en la consulta!");
      } else {
        show_ldr(false);
        a = response.data;
      }
    })
    .catch(function (error) {
      notifica("warning", error, "");
      show_ldr(false);
      a = [];
    })
    .then(() => _callback(a));
}

//Función que trae el detalle de la vacante
function getDetalleVacante(_callback, id) {
  var user = getUser();
  const parameters = new URLSearchParams();
  parameters.append('idSolicitud', id);
  parameters.append('idCandidato', user ? user.idCandidato : 0);
  parameters.append('idUsuarioAct', user ? user.idCandidato : 1);
  api.get('solicitudes/publicadas-detalle?' + parameters.toString(), {})
    .then(function (response) {
      if (response.status !== 200) {
        notifica("warning", response.data.message, "Error en la consulta!");
      } else {
        b = response.data;
      }
    })
    .catch(function (error) {

      notifica("danger", error, "Error");
    })
    .then(() => _callback(b));
}

//Función para postularse
function postularse(_callback) {
  var idSolicit = document.getElementById("Id_Vacante").innerText,
    idZonific = document.getElementById("Id_Zonificacion").innerText,
    prestador = document.getElementById("prestador").innerText,
    user = getUser();
  show_ldr(true);
  var json = {
    idSolicitud: parseInt(idSolicit, 10),
    idZonificacion: parseInt(idZonific, 10),
    idCandidato: user.idCandidato
  };

  if (prestador == 2) json.idPrestador = +prestador;
  
  axios({
    method: "post",
    url: cnxAPI + "Candidato/Postularse",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      "X-Requested-With": "XMLHttpRequest"
    },
    data: json
  })
    .then(function (response) {
      show_ldr(false);
      if (response.status !== 200) {
        notifica("warning", response.data.message, "Error en la consulta!");
      } else {
        b = response.data;
      }
    })
    .catch(function (error) {
      notifica("warning", error, "Error");
    })
    .then(() => _callback(b));
}
function postularseNew(data, _callback) {
  var idSolicit = data.idSolicitud,
    idZonific = data.idZonificacion,
    user = getUser();
  show_ldr(true);
  var json = {
    idSolicitud: parseInt(idSolicit, 10),
    idZonificacion: parseInt(idZonific, 10),
    idCandidato: user.idCandidato
  };


  axios({
    method: "post",
    url: cnxAPI + "Candidato/Postularse",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      "X-Requested-With": "XMLHttpRequest"
    },
    data: json
  })
    .then(function (response) {

      if (response.status !== 200) {
        notifica("warning", response.data.message, "Error en la consulta!");
      } else {
        b = response.data;
      }
    })
    .catch(function (error) {
      notifica("warning", error, "Error");
    })
    .then(() => _callback(b));
}


export const postPostularCandidatoFormulario = async (datos = {}, idSolicitud, idZonificacion) => {
  const { _name, _apellidoP, _apellidoM, _telefono, file, idEstado } = datos;
  const formData = new FormData();
  const prestador = document.getElementById("prestador").innerText;

  if (datos._name) {
    formData.append('idSolicitud', idSolicitud);
    formData.append('idZonificacion', idZonificacion);
    formData.append('primerNombre', _name);
    formData.append('apellidoPaterno', _apellidoP);
    formData.append('apellidoMaterno', _apellidoM);
    formData.append('telefono1', _telefono);
    formData.append('idEstado', idEstado);
    formData.append('archivoCv', file);
    formData.append('idTipoLogin', 2);
  }
  let request = await service.post(`/candidatos`, formData).then(responseBuild);
  if (request) {
    /**
     * Function to register candidato
     */
    let data = { idCandidato: request.id, idSolicitud, idZonificacion, notNotificationSend: true, idOrigenPostulacion: 2 };
    
    if (prestador == 2) {
      data.idPrestador =  +prestador;
    }

    await service.setToken();
    /**
     * Function to add candidato
     */
    let postulationRequest = await service.post(`/candidatos/postular`, data).then(responseBuild);
    if (postulationRequest) {
      return postulationRequest;
    }

  }
  return {}
}
function esperar(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export const postPostularCandidato = async () => {
  await service.setToken()
  const prestador = document.getElementById("prestador").innerText;
  const user = getUser();
  let data = {
    option: "postulate-candidate",
    data : {
      idCandidato: user.idCandidato, 
      idSolicitud : document.getElementById("Id_Vacante").innerText,
      idZonificacion : document.getElementById("Id_Zonificacion").innerText,
      notNotificationSend : true,
    }
  }
  
  if (prestador == 2) data.data.idPrestador = +prestador;
  data.data = JSON.stringify(data.data);

  const request = await service.post('/solicitudes/process-request', data).then(responseBuild);
  
  if (request) {
    return request
  }
  await esperar(4000); 
  return {}
}


function GetPreguntasInicialesEntrevista(data, _callback) {
  var idSolicit = data;
  show_ldr(true);
  const parameters = new URLSearchParams();
  parameters.append('idSolicitud', parseInt(idSolicit, 10));
  parameters.append('idUsuarioAct', 1);
  api.get('solicitudes/preguntas-iniciales-entrevista?' + parameters.toString(), {})
    .then(function (response) {
      if (response.status !== 200 && response.status !== 204) {
        notifica("warning", "Error en la consulta", "Error en la consulta!");
      } else {
        b = response.data;
      }
      show_ldr(false);
    })
    .catch(function (error) {
      notifica("warning", error, "Error");
      b = null;
    })
    .then(() => _callback(b));
}

function GuardarRespuestasInicialesCandidato(data, _callback) {
  show_ldr(true);
  var b;
  axios({
    method: "post",
    url: cnxAPI + "Solicitudes/GuardarRespuestasInicialesCandidato",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      "X-Requested-With": "XMLHttpRequest"
    },
    data: data
  })
    .then(function (response) {

      if (response.data.code !== 0) {
        notifica("warning", response.data.message, "Error en la consulta!");
      } else {
        b = response;
      }
      show_ldr(false);
    })
    .catch(function (error) {
      notifica("warning", error, "Error");
    })
    .then(() => _callback(b));

}
export { getVacantes, getDetalleVacante, postularse, postularseNew, GetPreguntasInicialesEntrevista, GuardarRespuestasInicialesCandidato };
